import { Model } from '@/clients/http'

import { AuthHttpParams, AuthResponses } from '@/types'

export class AuthModel extends Model {
  public static readonly correlations = {
    LOGIN: 'AUTH_LOGIN',
    LOGOUT: 'AUTH_LOGOUT',
    GET_AUTH_USER: 'AUTH_USER',
  }

  public static readonly endpoints = {
    login: () => '/api/backoffice/login',
    logout: () => '/api/backoffice/logout',
    getAuthUser: () => '/api/backoffice/profile',
  }

  public static readonly login = async (props: AuthHttpParams.Login) => {
    return this.createHttpRequest<AuthResponses.Login, AuthResponses.LoginError>({
      correlationKey: this.correlations.LOGIN,
      payload: {
        method: 'post',
        url: this.endpoints.login(),
        body: props.body,
      },
      store: props.store,
    })
  }

  public static readonly logout = async (props?: AuthHttpParams.Logout) => {
    return this.createHttpRequest<void>({
      correlationKey: this.correlations.LOGOUT,
      payload: {
        method: 'post',
        url: this.endpoints.logout(),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly getAuthUser = async (props?: AuthHttpParams.GetAuthUser) => {
    return this.createHttpRequest<AuthResponses.AuthUser>({
      correlationKey: this.correlations.GET_AUTH_USER,
      payload: {
        method: 'get',
        url: this.endpoints.getAuthUser(),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
